import React from 'react';
import classNames from 'classnames';
import { useStyles } from './RowWrapper.styles';
var RowWrapper = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return (React.createElement("div", { className: classNames('flex-row flex-center', classes.wrapper) }, children));
};
export { RowWrapper };
